<div class="layout-wrapper" (click)="onWrapperClick()"
    [ngClass]="{'layout-wrapper-static': layoutMode === 'static',
                'layout-wrapper-active': mobileMenuActive,
                'layout-menu-horizontal': layoutMode === 'horizontal',
                'layout-rtl': isRTL}">

    <app-menu [reset]="resetMenu" *ngIf="isShowMenu && !isContentFullScreen"></app-menu>

    <div class="layout-main" [ngClass]="isContentFullScreen ? 'content-full-screen' : ''">
        <app-topbar *ngIf="isUsuarioLogado && isShowTopbar && !isContentFullScreen"></app-topbar>

        <app-breadcrumb id="app-breadcrumb" *ngIf="isUsuarioLogado && isShowBreadcrumb"></app-breadcrumb>
        <app-topbar-filter class="no-print" id='app-topbar-filter' *ngIf="isUsuarioLogado && isShowTopbarFilter"></app-topbar-filter>

        <div class="layout-content" [ngStyle]="isContentFullScreen ? {'padding': '0'} : {}">
          <router-outlet></router-outlet>
        </div>

        <app-footer *ngIf="isUsuarioLogado && isShowFooter && !isContentFullScreen"></app-footer>
        <div class="layout-main-mask" *ngIf="mobileMenuActive"></div>
    </div>
    <p-confirmDialog rejectLabel="Não" acceptLabel="Sim"></p-confirmDialog>


    <!-- <app-overlay-panel #overlayPanel></app-overlay-panel> -->
    <app-bottom-panel #bottomPanel></app-bottom-panel>
</div>
